import axiosIns from "@/api/axios";

export default {
  name: "Certificate",
  computed: {
    certificates() {
      return this.$store.getters["certificate/getCertificates"] || [];
    },
    totalItems() {
      return this.$store.getters["certificate/getTotalItems"] || 0;
    },
    totalPages() {
      return this.$store.getters["certificate/getTotalPages"] || 1;
    },
    isLoading() {
      return this.$store.getters["certificate/getLoading"];
    },
    categoryOptions() {
      return this.$store.getters["trainingCategory/getTrainingCategories"] || [];
    },
    // Pagination computed
    showingFrom() {
      if (this.totalItems === 0) return 0;
      return (this.body.page - 1) * this.body.limit + 1;
    },
    showingTo() {
      const to = this.body.page * this.body.limit;
      return to > this.totalItems ? this.totalItems : to;
    },
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.body.page;
      
      // Always show at least page 1
      if (total <= 1) {
        pages.push(1);
      } else if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        
        if (current > 3) {
          pages.push('...');
        }
        
        const start = Math.max(2, current - 1);
        const end = Math.min(total - 1, current + 1);
        
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }
        
        if (current < total - 2) {
          pages.push('...');
        }
        
        pages.push(total);
      }
      
      return pages;
    }
  },
  data() {
    return {
      imageBaseUrl: process.env.VUE_APP_API_URL_UGEMS_UNIV,
      // Dummy certificates data
      // dummyCertificates: [
      //   {
      //     id: 1,
      //     name: "Vue.js Advanced Certification",
      //     type: "External",
      //     category: "PWD",
      //     validity_period: 36, // 3 years = 36 months
      //     image_url: "https://placehold.co/400x300/007bff/ffffff?text=Vue.js+Certificate",
      //     created_at: "2024-01-15T10:30:00Z",
      //     updated_at: "2024-01-15T10:30:00Z"
      //   },
      //   {
      //     id: 2,
      //     name: "Project Management Professional",
      //     type: "Internal",
      //     category: "PSM",
      //     validity_period: 24, // 2 years = 24 months
      //     image_url: "https://placehold.co/400x300/28a745/ffffff?text=PMP+Certificate",
      //     created_at: "2024-02-20T14:15:00Z",
      //     updated_at: "2024-02-20T14:15:00Z"
      //   },
      //   {
      //     id: 3,
      //     name: "Data Analysis with Python",
      //     type: "Thematic",
      //     category: "PTD",
      //     validity_period: 60, // 5 years = 60 months
      //     image_url: "https://placehold.co/400x300/ffc107/000000?text=Python+Certificate",
      //     created_at: "2024-03-10T09:45:00Z",
      //     updated_at: "2024-03-10T09:45:00Z"
      //   },
      //   {
      //     id: 4,
      //     name: "Cloud Architecture Fundamentals",
      //     type: "External",
      //     category: "PWP",
      //     validity_period: 30, // 2 years 6 months = 30 months
      //     image_url: "https://placehold.co/400x300/17a2b8/ffffff?text=Cloud+Certificate",
      //     created_at: "2024-04-05T16:20:00Z",
      //     updated_at: "2024-04-05T16:20:00Z"
      //   },
      //   {
      //     id: 5,
      //     name: "Agile Methodology Training",
      //     type: "Internal",
      //     category: "PKK",
      //     validity_period: 18, // 1 year 6 months = 18 months
      //     image_url: "https://placehold.co/400x300/dc3545/ffffff?text=Agile+Certificate",
      //     created_at: "2024-05-12T11:00:00Z",
      //     updated_at: "2024-05-12T11:00:00Z"
      //   },
      //   {
      //     id: 6,
      //     name: "Leadership Excellence Program",
      //     type: "Thematic",
      //     category: "PPF",
      //     validity_period: 24, // 2 years = 24 months
      //     image_url: "https://placehold.co/400x300/6f42c1/ffffff?text=Leadership+Certificate",
      //     created_at: "2024-06-18T13:30:00Z",
      //     updated_at: "2024-06-18T13:30:00Z"
      //   },
      //   {
      //     id: 7,
      //     name: "Digital Marketing Specialist",
      //     type: "External",
      //     category: "PLH",
      //     validity_period: 48, // 4 years = 48 months
      //     image_url: "https://placehold.co/400x300/fd7e14/ffffff?text=Marketing+Certificate",
      //     created_at: "2024-07-22T08:15:00Z",
      //     updated_at: "2024-07-22T08:15:00Z"
      //   },
      //   {
      //     id: 8,
      //     name: "Cybersecurity Awareness",
      //     type: "Internal",
      //     category: "PWD",
      //     validity_period: 12, // 1 year = 12 months
      //     image_url: "https://placehold.co/400x300/343a40/ffffff?text=Security+Certificate",
      //     created_at: "2024-08-14T15:45:00Z",
      //     updated_at: "2024-08-14T15:45:00Z"
      //   },
      //   {
      //     id: 9,
      //     name: "Machine Learning Fundamentals",
      //     type: "Thematic",
      //     category: "PSM",
      //     validity_period: 42, // 3 years 6 months = 42 months
      //     image_url: "https://placehold.co/400x300/20c997/ffffff?text=ML+Certificate",
      //     created_at: "2024-09-03T12:20:00Z",
      //     updated_at: "2024-09-03T12:20:00Z"
      //   }
      // ],
      listTabMenu: {
        privilages: {
          create: true,
          read: true,
          update: true,
          delete: true
        }
      },
      body: {
        page: 1,
        limit: 9, // 3x3 grid
        search: "",
        type: "",
        category: ""
      },
      perPageOptions: [10, 50, 100],
      filters: {
        type: "",
        category: "",
        search: ""
      },
      bodyAdd: {
        training_category_id: null,
        type: "",
        // validity_period_in_months: 0,
        // validity_year: 0,
        // validity_month: 0,
        file: null
      },
      bodyUpdate: {
        id: null,
        training_category_id: null,
        type: "",
        // validity_period_in_months: 0,
        // validity_year: 0,
        // validity_month: 0,
        file: null,
        image_url: ""
      },
      viewDetailData: {},
      isAdd: true,
      modalTitle: "Add Certificate",
      searchTimeout: null,
      // yearOptions: [
      //   { label: '0 Year', value: 0 },
      //   { label: '1 Year', value: 1 },
      //   { label: '2 Years', value: 2 },
      //   { label: '3 Years', value: 3 },
      //   { label: '4 Years', value: 4 },
      //   { label: '5 Years', value: 5 }
      // ],
      // monthOptions: [
      //   { label: '0 Month', value: 0 },
      //   { label: '1 Month', value: 1 },
      //   { label: '2 Months', value: 2 },
      //   { label: '3 Months', value: 3 },
      //   { label: '4 Months', value: 4 },
      //   { label: '5 Months', value: 5 },
      //   { label: '6 Months', value: 6 },
      //   { label: '7 Months', value: 7 },
      //   { label: '8 Months', value: 8 },
      //   { label: '9 Months', value: 9 },
      //   { label: '10 Months', value: 10 },
      //   { label: '11 Months', value: 11 },
      //   { label: '12 Months', value: 12 }
      // ],
      typeOptions: [
        'Internal',
        'External', 
        'Thematic'
      ],
      formErrors: {},
      previewUrl: "",
      selectedCertificate: null,
      isSubmitting: false
    };
  },
  mounted() {
    // Load main data
    this.getCertificates(); // Commented API call - using dummy data
    
    // Load training categories for categoryOptions
    this.getTrainingCategories();
    
    // Set menu permissions
    this.setMenuPermissions();
    
    // Initialize dummy data (already in data() but can be called for refresh)
    // console.log("Certificate component mounted with dummy data");
  },
  methods: {
    // Set menu permissions
    setMenuPermissions() {
      const listMenu = JSON.parse(localStorage.getItem('listMenu') || '[]');
      const currentPath = window.location.pathname;
      const menu = listMenu.find((menu) =>
        menu.link === String(currentPath) || menu.children.some((child) => child.link === String(currentPath))
      );
      this.listTabMenu = menu ? menu.children.find((item) => item.link === currentPath) || menu : {};
    },

    // Year/Month handling methods
    // getTotalMonths(formType) {
    //   const form = formType === 'add' ? this.bodyAdd : this.bodyUpdate;
    //   return (form.validity_year || 0) * 12 + (form.validity_month || 0);
    // },

    // getMonthOptions(formType) {
    //   const form = formType === 'add' ? this.bodyAdd : this.bodyUpdate;
    //   const selectedYear = form.validity_year || 0;
    //   const maxTotalMonths = 60; // 5 years = 60 months
    //   const usedMonths = selectedYear * 12;
    //   const availableMonths = maxTotalMonths - usedMonths;
    //   
    //   return this.monthOptions.filter(month => month.value <= availableMonths);
    // },

    // isMonthDisabled(formType) {
    //   const form = formType === 'add' ? this.bodyAdd : this.bodyUpdate;
    //   return (form.validity_year || 0) >= 5;
    // },

    // onYearChange(formType) {
    //   const form = formType === 'add' ? this.bodyAdd : this.bodyUpdate;
    //   
    //   // If year is 5, set month to 0 and disable month selection
    //   if (form.validity_year >= 5) {
    //     form.validity_month = 0;
    //   }
    //   
    //   // Check if current month selection exceeds limit
    //   const maxAllowedMonths = (5 - form.validity_year) * 12;
    //   if (form.validity_month > maxAllowedMonths) {
    //     form.validity_month = 0;
    //   }
    //   
    //   this.updateValidityPeriod(formType);
    // },

    // onMonthChange(formType) {
    //   this.updateValidityPeriod(formType);
    // },

    // updateValidityPeriod(formType) {
    //   const form = formType === 'add' ? this.bodyAdd : this.bodyUpdate;
    //   const totalMonths = this.getTotalMonths(formType);
    //   
    //   // Convert total months to API format (just send total months)
    //   form.validity_period_in_months = totalMonths;
    // },

    // // Convert months back to year/month for editing
    // convertMonthsToYearMonth(totalMonths, formType) {
    //   const form = formType === 'add' ? this.bodyAdd : this.bodyUpdate;
    //   const years = Math.floor(totalMonths / 12);
    //   const months = totalMonths % 12;
    //   
    //   form.validity_year = years;
    //   form.validity_month = months;
    //   form.validity_period_in_months = totalMonths;
    // },

    // Search with debounce
    onSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.body.search = this.filters.search;
        this.body.page = 1;
        this.getCertificates(); // Commented API call - using dummy data
        // console.log("Search performed - using dummy data");
      }, 500);
    },

    // Filter change
    onFilterChange() {
      this.body.type = this.filters.type;
      this.body.category = this.filters.category;
      this.body.page = 1;
      this.getCertificates(); // Commented API call - using dummy data
      // console.log("Filter changed - using dummy data");
    },

    // Clear all filters
    clearFilter() {
      this.filters = {
        type: "",
        category: "",
        search: ""
      };
      this.body = {
        page: 1,
        limit: 9,
        search: "",
        type: "",
        category: ""
      };
      this.getCertificates(); // Commented API call - using dummy data
      // console.log("Filters cleared - using dummy data");
    },

    // Actions
    addCertificate() {
      this.isAdd = true;
      this.modalTitle = "Add Certificate";
      this.resetAddForm();
      this.$bvModal.show("modal-certificate");
    },

    viewCertificate(data) {
      this.selectedCertificate = data;
      this.$bvModal.show("modal-preview");
    },

    editCertificate(data) {
      this.isAdd = false;
      this.modalTitle = "Edit Certificate";
      
      // Reset form data first
      this.resetUpdateForm();
      
      // Populate form with existing data
      this.bodyUpdate = {
        id: data.id,
        training_category_id: data.training_category_id,
        type: data.type || "",
        // validity_period_in_months: data.validity_period_in_months || 0,
        // validity_year: 0,
        // validity_month: 0,
        file: null,
        image_url: data.image_url || ""
      };
      
      // // Convert existing validity_period_in_months to year/month
      // if (data.validity_period_in_months) {
      //   const totalMonths = parseInt(data.validity_period_in_months) || 0;
      //   this.convertMonthsToYearMonth(totalMonths, 'update');
      // }
      
      this.formErrors = {};
      this.previewUrl = "";
      this.$bvModal.show("modal-certificate");
    },

    deleteCertificate(data) {
      this.$swal({
        title: "Apakah Anda yakin?",
        text: "Tindakan ini tidak dapat dibatalkan!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Batal"
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            // Commented API call - simulate deletion with dummy data
            await this.$store.dispatch("certificate/deleteCertificate", data.id);
            
            // Remove from dummy data
            // const index = this.dummyCertificates.findIndex(cert => cert.id === data.id);
            // if (index > -1) {
            //   this.dummyCertificates.splice(index, 1);
            // }
            
            this.$swal("Terhapus", "Sertifikat telah dihapus", "success");
            this.getCertificates(); // Commented API call
          } catch (error) {
            this.$swal("Error", "Sertifikat belum berhasil dihapus", "error");
          }
        }
      });
    },

    resetAddForm() {
      this.bodyAdd = {
        training_category_id: null,
        type: "",
        // validity_period_in_months: 0,
        // validity_year: 0,
        // validity_month: 0,
        file: null
      };
      this.formErrors = {};
      this.previewUrl = "";
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },

    resetUpdateForm() {
      this.bodyUpdate = {
        id: null,
        training_category_id: null,
        type: "",
        // validity_period_in_months: 0,
        // validity_year: 0,
        // validity_month: 0,
        file: null,
        image_url: ""
      };
      this.formErrors = {};
      this.previewUrl = "";
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },

    resetForm() {
      if (this.isAdd) {
        this.resetAddForm();
      } else {
        this.resetUpdateForm();
      }
    },

    // File handling methods
    chooseFile() {
      this.$refs.fileInput.click();
    },

    handleFileSelect(event) {
      const file = event.target.files[0];
      if (file) {
        this.processFile(file);
      }
    },

    handleDrop(event) {
      event.preventDefault();
      const file = event.dataTransfer.files[0];
      if (file) {
        this.processFile(file);
      }
    },

    processFile(file) {
      // Validate file size (2MB)
      if (file.size > 2 * 1024 * 1024) {
        this.$swal("Error", "Ukuran file tidak boleh lebih dari 2MB", "error");
        return;
      }

      // Validate file type
      const allowedTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
                           'application/vnd.ms-excel', 
                           'application/pdf',
                           'image/jpeg', 
                           'image/jpg', 
                           'image/png'];
      if (!allowedTypes.includes(file.type)) {
        this.$swal("Error", "Hanya file .xlsx, .xls, .pdf, .jpg, .jpeg, .png yang diizinkan", "error");
        return;
      }

      if (this.isAdd) {
        this.bodyAdd.file = file;
      } else {
        this.bodyUpdate.file = file;
      }
      
      // Create preview for images
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.previewUrl = ""; // For non-image files
      }

      // Clear file error
      if (this.formErrors.file) {
        delete this.formErrors.file;
      }
    },

    removeFile() {
      if (this.isAdd) {
        this.bodyAdd.file = null;
      } else {
        this.bodyUpdate.file = null;
        this.bodyUpdate.image_url = "";
      }
      this.previewUrl = "";
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },

    // Form validation
    validateForm() {
      this.formErrors = {};
      const formData = this.isAdd ? this.bodyAdd : this.bodyUpdate;

      if (!formData.type) {
        this.formErrors.type = "Type is required";
      }

      if (!formData.training_category_id) {
        this.formErrors.category = "Category is required";
      }

      // Validate validity period (total months)
      // const totalMonths = this.getTotalMonths(this.isAdd ? 'add' : 'update');
      // if (totalMonths === 0) {
      //   this.formErrors.validity_period = "Validity period is required (minimum 1 month)";
      // } else if (totalMonths > 60) {
      //   this.formErrors.validity_period = "Validity period cannot exceed 5 years (60 months)";
      // }

      if (this.isAdd && !formData.file) {
        this.formErrors.file = "File is required";
      }

      return Object.keys(this.formErrors).length === 0;
    },

    // Save methods
    async saveCertificate() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;

      try {
        const formData = new FormData();
        const data = this.isAdd ? this.bodyAdd : this.bodyUpdate;
        
        formData.append('type', data.type);
        formData.append('training_category_id', data.training_category_id);
        // formData.append('validity_period_in_months', data.validity_period_in_months);
        if (data.file) {
          formData.append('image', data.file);
        }

        if (this.isAdd) {
          // Commented API call - simulate with dummy data
          await this.$store.dispatch("certificate/createCertificate", formData);
          
          // Add to dummy data
          // const newCertificate = {
          //   id: Math.max(...this.dummyCertificates.map(c => c.id)) + 1,
          //   name: data.name || "New Certificate",
          //   type: data.type,
          //   category: data.category,
          //   validity_period: data.validity_period,
          //   image_url: data.file ? URL.createObjectURL(data.file) : "https://via.placeholder.com/400x300/6c757d/ffffff?text=New+Certificate",
          //   created_at: new Date().toISOString(),
          //   updated_at: new Date().toISOString()
          // };
          // this.dummyCertificates.push(newCertificate);
          
          this.$swal({
            title: "Success",
            text: "Sertifikat berhasil ditambahkan",
            icon: "success",
            confirmButtonText: "OK"
          }).then(() => {
            this.getCertificates(); // Commented API call
            this.$bvModal.hide("modal-certificate");
            this.resetAddForm();
          });
        } else {
          // Commented API call - simulate with dummy data
          await this.$store.dispatch("certificate/updateCertificate", {
            id: this.bodyUpdate.id,
            data: formData
          });
          
          // Update dummy data
          // const index = this.dummyCertificates.findIndex(cert => cert.id === data.id);
          // if (index > -1) {
          //   this.dummyCertificates[index] = {
          //     ...this.dummyCertificates[index],
          //     name: data.name || this.dummyCertificates[index].name,
          //     type: data.type,
          //     category: data.category,
          //     validity_period: data.validity_period,
          //     image_url: data.file ? URL.createObjectURL(data.file) : this.dummyCertificates[index].image_url,
          //     updated_at: new Date().toISOString()
          //   };
          // }
          
          this.$swal({
            title: "Success",
            text: "Sertifikat berhasil diperbarui",
            icon: "success",
            confirmButtonText: "OK"
          }).then(() => {
            this.getCertificates(); // Commented API call
            this.$bvModal.hide("modal-certificate");
          });
        }
      } catch (error) {
        console.error('Error saving certificate:', error);
        let errorMessage = "Error while saving certificate";
        
        // Handle API error response
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          if (errorData.httpCode === 400 && errorData.error) {
            errorMessage = errorData.error;
          } else if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.httpMessage) {
            errorMessage = errorData.httpMessage;
          }
        }
        
        this.$swal("Error", errorMessage, "error");
      } finally {
        this.isSubmitting = false;
      }
    },

    // API calls
    getCertificates() {
      // Commented API call - using dummy data instead
      this.$store.dispatch("certificate/getCertificates", this.body);
      // console.log("getCertificates() called - using dummy data");
    },

    getTrainingCategories() {
      // Load training categories for dropdown options
      this.$store.dispatch("trainingCategory/getTrainingCategories", {
        page: 1,
        limit: 100, // Get all categories for dropdown
        search: ""
      });
    },

    // Pagination
    onPageChange(page) {
      this.body.page = page;
      this.getCertificates();
    },

    onPerPageChange() {
      this.body.page = 1; // Reset to first page when changing per page
      this.getCertificates();
    },

    changePage(page) {
      if (page === '...' || page < 1 || page > this.totalPages) return;
      this.body.page = page;
      this.getCertificates();
    },

    // Utility methods
    getTypeBadgeClass(type) {
      switch (type) {
        case 'Internal':
          return 'badge-success';
        case 'External':
          return 'badge-primary';
        case 'Thematic':
          return 'badge-info';
        default:
          return 'badge-secondary';
      }
    },

    formatValidityPeriod(date) {
      if (!date) return 'Not specified';
      try {
        return new Date(date).toLocaleDateString('en-GB');
      } catch (error) {
        return 'Invalid date';
      }
    }
  }
};